var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"Main-wrapper"},[_c('v-container',{attrs:{"id":"main-layout","fluid":"","tag":"section"}},[((_vm.user.role[0] != 'OMS Role') || (_vm.user.user_nature != 'cso'))?_c('Notification'):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }